// Import database client
import databaseClient from '../databaseClient';

// ------------------------------------------------------------------------------
// GETTER
// ------------------------------------------------------------------------------

// Get all products from the db
export async function getAllProducts() {
    const { data, error } = await databaseClient.rpc('get_all_products');

    // If there is an throw it
    if (error) {
        throw error;
    }

    return data;
}

// Get product by id
export async function getProductById(productId) {
    const { data, error } = await databaseClient.rpc('get_product_by_id', {
        prod_id: productId,
    });

    // If there is an error throws it
    if (error) {
        throw error;
    }

    return data;
}

// Get product images using product uuid
export async function getProductImages(productId) {
    const { data, error } = await databaseClient.rpc('get_product_images', {
        prod_id: productId,
    });

    // If there is an throw it
    if (error) {
        throw error;
    }

    return data;
}

// ------------------------------------------------------------------------------
// INSERT, UPDATE, DELETE
// ------------------------------------------------------------------------------

// Create product with images
export async function createProduct(
    productName,
    productDescription,
    productIsOffer,
    productPrice,
    productImages = null,
) {
    const { data, error } = await databaseClient.rpc(
        'add_product_with_images',
        {
            p_name: productName,
            p_description: productDescription,
            p_price: productPrice,
            p_is_offer: productIsOffer,
            p_images: productImages,
        },
    );

    // If there is an throw it
    if (error) {
        throw error;
    }

    return data;
}

// Delete a product
export async function deleteProduct(productId) {
    const { error } = await databaseClient.rpc('delete_product_and_images', {
        p_id: productId,
    });

    // If there is an throw it
    if (error) {
        throw error;
    }
}

// Update product
export async function editProduct(
    productId,
    productNewName = null,
    productNewDescription = null,
    productNewIsOffer = null,
    productNewPrice = null,
) {
    const { error } = await databaseClient.rpc('update_product_fields', {
        p_id: productId,
        p_name: productNewName,
        p_description: productNewDescription,
        p_price: productNewPrice,
        p_is_offer: productNewIsOffer,
    });

    // If there is an throw it
    if (error) {
        throw error;
    }
}

// Add image for a designated product
export async function addImageToProduct(productId, imagePath) {
    const { data, error } = await databaseClient.rpc('add_image_to_product', {
        p_id: productId,
        i_path: imagePath,
    });

    // If there is an throw it
    if (error) {
        throw error;
    }

    return data;
}

// Delete an image
export async function deleteImage(imageId) {
    const { error } = await databaseClient.rpc('delete_image_by_id', {
        i_id: imageId,
    });

    // If there is an throw it
    if (error) {
        throw error;
    }
}
